export default __webpack_public_path__ + "static/media/step4.2ff5b3ad.png";